/* eslint-disable */
import FuseAnimate from '@/@fuse/core/FuseAnimate';
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import { getImmunizations } from '@/app/services/immunizations/Immunization';
import { getImmunizationsReport, getRooms } from '@/app/services/reports/reports';
import * as Actions from '@/app/store/actions';
import { generateAgeString, getAgeDetails } from '@/utils/utils';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	Avatar,
	CircularProgress,
	FormControl,
	IconButton,
	InputAdornment,
	InputLabel,
	MenuItem,
	Select,
	TextField,
	Typography,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import dayjs from 'dayjs';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import './Reports.css';
import { useNavigate } from 'react-router-dom';
let memo = {};

const ImmunizationReport = () => {
	const dispatch = useDispatch();
	const user = useSelector(({ auth }) => auth.user);
	let positiveRecords = 0;
	const [rows, setRows] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [hasMore, setHasMore] = useState(false);
	const [firstLoad, setFirstLoad] = useState(true);
	const [fetchingMore, setFetchingMore] = useState(false);
	const [fromDate1, setFromDate1] = useState();
	const [toDate1, setToDate1] = useState();
	const [page, setPage] = useState(1);
	const [filters, setFilters] = useState({
		school_id: user?.school?.id || user?.data?.school?.id,
		name: '',
		room_id: '',
		status: 1,
		date_from: '',
		date_to: '',
		export: 0,
	});
	const [rooms, setRooms] = useState([]);
	const [roomPage, setRoomPage] = useState(1);
	const [isLoadingExport, setIsLoadingExport] = useState(false);
	const [immunizationsList, setImmunizationsList] = useState([]);
	const date = new Date();
	const studentAgeRef = useRef(null);
	const navigate = useNavigate();
	const handlePrint = useReactToPrint({
		content: () => studentAgeRef.current,
	});

	const handleFilters = (ev) => {
		const { name, value } = ev.target;
		setFilters({ ...filters, [name]: value });
	};

	useEffect(() => {
		let isMounted = true;
		getRooms('', roomPage)
			.then((res) => {
				if (!isMounted) return;
				setRooms([...rooms, ...res.data.data]);
				if (res.data.current_page < res.data.last_page) {
					setRoomPage(roomPage + 1);
				}
			})
			.catch((err) => {
				if (!isMounted) return;
				dispatch(
					Actions.showMessage({
						message: 'Failed to get rooms.',
						autoHideDuration: 1500,
						variant: 'error',
					}),
				);
			});
		getImmunizations().then((res) => {
			if (!isMounted) return;
			setImmunizationsList(res.data);
		});
		return () => {
			isMounted = false;
		};
	}, [roomPage, dispatch]);

	const handleExport = () => {
		setIsLoadingExport(true);
		getImmunizationsReport(
			1,
			filters.name,
			filters.school_id,
			filters.room_id === 'All' ? '' : filters.room_id,
			filters.status,
			filters.date_from === '5yearsorabove' ? '' : filters.date_from,
			filters.date_to === '0' ? '' : filters.date_to,
			'', // no page in export
			1, // 1 for due overdue format change
		)
			.then((res) => {
				const blob = new Blob([res.data], {
					type: 'text/csv',
				});
				const link = document.createElement('a');
				link.setAttribute('target', '_blank');
				link.href = window.URL.createObjectURL(blob);
				link.setAttribute('download', `student-immunization-report-${new Date().getTime()}.csv`);
				document.body.appendChild(link);
				link.click();
				// Clean up and remove the link
				link.parentNode.removeChild(link);
				setIsLoadingExport(false);
			})
			.catch((err) => {
				dispatch(
					Actions.showMessage({
						message: 'Failed to Export',
						variant: 'error',
					}),
				);
				setIsLoadingExport(false);
			})
			.finally(() => {
				setIsLoadingExport(false);
			});
	};

	const ApplyFilters = () => {
		memo = {};
		setRows([]);
		setIsLoading(true);
		setFirstLoad(false);
		getImmunizationsReport(
			0, // Zero for export
			filters.name,
			filters.school_id,
			filters.room_id === 'All' ? '' : filters.room_id,
			filters.status,
			filters.date_from === '5yearsorabove' ? '' : filters.date_from,
			filters.date_to === '0' ? '' : filters.date_to,
			1,
		)
			.then((res) => {
				setFirstLoad(false);
				setRows(res.data.data);
				if (res.data.last_page > res.data.current_page) {
					setHasMore(true);
				} else {
					setHasMore(false);
				}
				setPage(res.data.current_page + 1);
				dispatch(
					Actions.showMessage({
						message: 'Report has been generated',
						variant: 'success',
					}),
				);
			})
			.catch((err) => {
				dispatch(
					Actions.showMessage({
						message: 'Failed to fetch data, please refresh',
						variant: 'error',
					}),
				);
			})
			.finally(() => {
				setIsLoading(false);
			});
		setPage(1);
	};

	const handleLoadMore = () => {
		setFetchingMore(true);
		getImmunizationsReport(
			0, // Zero for export
			filters.name,
			filters.school_id,
			filters.room_id === 'All' ? '' : filters.room_id,
			filters.status,
			filters.date_from === '5yearsorabove' ? '' : filters.date_from,
			filters.date_to === '0' ? '' : filters.date_to,
			page,
		)
			.then((res) => {
				if (res.data.last_page > res.data.current_page) {
					setHasMore(true);
				} else {
					setHasMore(false);
				}
				setPage(res.data.current_page + 1);
				setRows(rows.concat(res.data.data));
				setFetchingMore(false);
			})
			.catch((err) => {
				setFetchingMore(false);
				dispatch(
					Actions.showMessage({
						message: 'Failed to fetch data, please refresh',
						variant: 'error',
					}),
				);
			});
	};

	const findNextDoseIndex = (im, age, memoizedData) => {
		const doses = im.meta;
		if (memoizedData[im.id]) {
			return memoizedData[im.id];
		}
		for (let i = 0; i < doses.length; i += 1) {
			if (!doses[i].date && !doses[i].skip) {
				// console.log('No date and not skipped');
				if (!Number(doses[i].is_recurring)) {
					// console.log('Not recurring');
					if (
						age?.allMonths >= Number(doses[i].min_duration) - 1 &&
						age?.allMonths <= Number(doses[i].max_duration) - 1
					) {
						// console.log('Age is in range');
						memo[im.id] = i;
						return i;
					}
					// console.log('Age is not in range');
				} else if (age?.allMonths % Number(doses[i].min_duration) === Number(doses[i].min_duration) - 1) {
					// console.log('recurring and 1 month before');
					memo[im.id] = i;
					return i;
				}
			}
		}
		memo[im.id] = -1;
		return -1;
	};

	const findOverdueIn30Days = (dose, age) => {
		if (!Number(dose.is_recurring) && age?.allMonths === Number(dose.max_duration) - 1) {
			return true;
		}
		return false;
	};

	const getFilterValue = (months) => {
		const d = new Date();
		// subtract months from d
		d.setMonth(d.getMonth() - months);
		return dayjs(d).format('YYYY-MM-DD');
	};

	return (
		<FuseAnimate animation="transition.slideLeftIn" duration={600}>
			<div className="mx-auto student-cont">
				<div className="flex items-center justify-between">
					<div className="schoolReport-topdiv">
						<h1 className="my-16">
							{' '}
							<span className="">
								<IconButton
									onClick={() => {
										navigate('/Reports');
									}}
								>
									<img alt="filter" className="" src="assets/images/arrow-long.png" width="24px" />
								</IconButton>
							</span>{' '}
							<span className="text-pd-xl self-end font-bold mr-28">Immunization Due/Over Due </span>
						</h1>
						<p>
							Use a CDC schedules and information about Immunization form each student profile to calculate which shots
							are upcoming and overdue
						</p>
					</div>
					<div className="flex justify-between">
						<div className="flex">
							{!isLoadingExport ? (
								<CustomButton height="40px" marginRight="17px" onClick={handleExport} variant="primary" width="100px">
									<span className="mr-4">
										<FontAwesomeIcon icon={faDownload} />
									</span>
									Export
								</CustomButton>
							) : (
								<div className="circle-bar">
									<CircularProgress size={35} />
								</div>
							)}
							<CustomButton height="40px" onClick={() => handlePrint()} variant="secondary" width="100px">
								<i aria-hidden="true" className="fa fa-print" /> Print
							</CustomButton>
						</div>
					</div>
				</div>

				<div className="flex items-center flex-nowrap justify-between">
					<span className="text-pd-2xl self-end font-extrabold mr-28" />
					<div className="flex justify-between">
						<div className="flex">
							<div className="mx-8">
								<TextField
									InputProps={{
										endAdornment: (
											<InputAdornment position="end">
												<IconButton
													id="search-icon"
													onClick={() => {
														document.getElementById('search-input').focus();
													}}
												>
													<img alt="search-icon" height="80%" src="assets/images/search-icon.svg" width="80%" />
												</IconButton>
											</InputAdornment>
										),
									}}
									className="mr-10"
									id="search-input"
									label="Search"
									name="name"
									onChange={handleFilters}
									style={{ width: 150 }}
									value={filters.name}
								/>
							</div>
							<div className="mx-8">
								<FormControl>
									<InputLabel id="roomId">Room</InputLabel>
									<Select
										endAdornment={
											filters.room_id ? (
												<IconButton className="mr-16" id="clear-room-filter" size="small">
													<Close
														fontSize="small"
														onClick={() => {
															setFilters({
																...filters,
																room_id: '',
															});
														}}
													/>
												</IconButton>
											) : (
												''
											)
										}
										id="room_id"
										label="Room"
										labelId="roomLabel"
										name="room_id"
										onChange={handleFilters}
										style={{ width: 150 }}
										value={filters.room_id}
									>
										<MenuItem value="All">All</MenuItem>
										{rooms.length ? (
											rooms.map((room) => {
												return (
													<MenuItem id={room.id} key={room.id} value={room.id}>
														{room.name}
													</MenuItem>
												);
											})
										) : (
											<MenuItem disabled>Loading...</MenuItem>
										)}
									</Select>
								</FormControl>
							</div>
							<div className="mx-8">
								<FormControl>
									<InputLabel id="status">Student's Status</InputLabel>
									<Select
										endAdornment={
											filters.status ? (
												<IconButton className="mr-16" id="clear-room-filter" size="small">
													<Close
														fontSize="small"
														onClick={() => {
															setFilters({
																...filters,
																status: '',
															});
														}}
													/>
												</IconButton>
											) : (
												''
											)
										}
										id="status"
										label="status"
										labelId="status"
										name="status"
										onChange={handleFilters}
										style={{ width: 150 }}
										value={filters.status}
									>
										<MenuItem value="1">Active</MenuItem>
										<MenuItem value="0">Inactive</MenuItem>
									</Select>
								</FormControl>
							</div>
						</div>
						<div className="mx-8">
							<FormControl>
								<InputLabel id="date_to_min">Min Age</InputLabel>
								<Select
									endAdornment={
										filters.date_to ? (
											<IconButton className="mr-16" id="date_to" size="small">
												<Close
													fontSize="small"
													onClick={() => {
														setFilters({
															...filters,
															date_to: '',
														});
														setToDate1('');
													}}
												/>
											</IconButton>
										) : (
											''
										)
									}
									id="date_to_select"
									label="Min Age"
									labelId="date_to_age"
									name="date_to"
									onChange={(ev) => {
										if (ev.target.value === '0') {
											setFilters({
												...filters,
												date_to: '0',
											});
										} else {
											setFilters({
												...filters,
												date_to: ev.target.value,
											});
										}
									}}
									style={{ width: 150 }}
									value={filters.date_to}
								>
									<MenuItem value="0">0 month</MenuItem>
									<MenuItem value={getFilterValue(6)}>6 month</MenuItem>
									<MenuItem value={getFilterValue(1 * 12)}>1 years</MenuItem>
									<MenuItem value={getFilterValue(1.5 * 12)}>1.5 years</MenuItem>
									<MenuItem value={getFilterValue(2 * 12)}>2 years</MenuItem>
									<MenuItem value={getFilterValue(2.5 * 12)}>2.5 years</MenuItem>
									<MenuItem value={getFilterValue(3 * 12)}>3 years</MenuItem>
									<MenuItem value={getFilterValue(3.5 * 12)}>3.5 years</MenuItem>
									<MenuItem value={getFilterValue(4 * 12)}>4 years</MenuItem>
									<MenuItem value={getFilterValue(4.5 * 12)}>4.5 years</MenuItem>
								</Select>
							</FormControl>
						</div>
						<div className="mx-8">
							<FormControl>
								<InputLabel id="date_from_max">Max Age</InputLabel>
								<Select
									endAdornment={
										filters.date_from ? (
											<IconButton className="mr-16" id="date_from" size="small">
												<Close
													fontSize="small"
													onClick={() => {
														setFilters({
															...filters,
															date_from: '',
														});
														setFromDate1('');
													}}
												/>
											</IconButton>
										) : (
											''
										)
									}
									id="date_from_select"
									label="Max Age"
									labelId="date_from_age"
									name="date_from"
									onChange={(ev) => {
										if (ev.target.value === '5yearsorabove') {
											setFilters({
												...filters,
												date_from: '5yearsorabove',
											});
										} else {
											setFilters({
												...filters,
												date_from: ev.target.value,
											});
										}
									}}
									style={{ width: 150 }}
									value={filters.date_from}
								>
									<MenuItem value={getFilterValue(6)}>6 month</MenuItem>
									<MenuItem value={getFilterValue(1 * 12)}>1 years</MenuItem>
									<MenuItem value={getFilterValue(1.5 * 12)}>1.5 years</MenuItem>
									<MenuItem value={getFilterValue(2 * 12)}>2 years</MenuItem>
									<MenuItem value={getFilterValue(2.5 * 12)}>2.5 years</MenuItem>
									<MenuItem value={getFilterValue(3 * 12)}>3 years</MenuItem>
									<MenuItem value={getFilterValue(3.5 * 12)}>3.5 years</MenuItem>
									<MenuItem value={getFilterValue(4 * 12)}>4 years</MenuItem>
									<MenuItem value={getFilterValue(4.5 * 12)}>4.5 years</MenuItem>
									<MenuItem value="5yearsorabove">5 years or above</MenuItem>
								</Select>
							</FormControl>
						</div>
						<div className="self-end">
							<span>
								<span className="mx-4">
									<CustomButton
										disabled={
											!filters.name && !filters.room_id && !filters.status && !filters.date_from
												? !filters.date_to
												: null
										}
										fontSize="15px"
										height="43"
										onClick={() => {
											ApplyFilters();
										}}
										variant="secondary"
										width="140px"
									>
										Apply
									</CustomButton>
								</span>
							</span>
						</div>
					</div>
				</div>
				<div style={{ display: 'none' }}>
					<div className="p-32" ref={studentAgeRef}>
						<div className="flex flex-row justify-between">
							<div>
								<img alt="" src="assets/images/logos/logo.png" />
							</div>
							<div style={{ textAlign: 'right' }}>
								<Typography
									style={{
										maxWidth: '220px',
									}}
									variant="subtitle1"
								>
									<span style={{ display: 'block', marginBottom: '5px', writingMode: '' }}>
										{user?.data?.school?.address}
									</span>
								</Typography>
								<Typography variant="subtitle1">+ {user?.data?.phone}</Typography>
								<Typography variant="subtitle1">{user?.data?.email}</Typography>
							</div>
						</div>
						<div style={{ marginBottom: '10px' }}>
							<span>
								<strong>Date: </strong>
							</span>
							<span>{moment(date).format('dddd, DD MMMM YYYY')}</span>
						</div>
						<div className="pdf-heading">
							<h1 className="font-extrabold">Immunization Due / Overdue Report</h1>
						</div>
						<div className="rounded-lg bg-white w-full mt-12 overflow-auto">
							<div className="mx-32 border-b">
								<div className="grid grid-cols-11 dueoverdueHeader">
									<div className="p-16 pl-0 col-span-2">Student</div>
									<div className="p-16 px-8 border-l col-span-3 flex justify-center">Due With in Next 30 Days</div>
									<div className="p-16 px-8 border-l col-span-3 flex justify-center">CDC Recommendation</div>
									<div className="p-16 px-8 border-l col-span-3 flex justify-center">Overdue With in Next 30 Days</div>
								</div>
							</div>
							{firstLoad ? (
								<div className="flex flex-row justify-center items-center" style={{ height: '70%' }}>
									Please Generate Your Report
								</div>
							) : isLoading ? (
								<div className="flex justify-center items-center" style={{ height: '70%' }}>
									<CircularProgress />
								</div>
							) : rows.length > 0 ? (
								<>
									{rows
										.filter((row) => row.immunizations.filter((i) => i.is_enabled && !i.is_exempted).length)
										.map((row) => {
											const age = getAgeDetails(dayjs(row.date_of_birth), dayjs());
											const imms = row.immunizations.filter((i) => i.is_enabled && !i.is_exempted);
											let flag = false;
											for (let i = 0; i < imms.length; i += 1) {
												const nextDoseIndex = findNextDoseIndex(imms[i], age, memo);
												if (nextDoseIndex !== -1) {
													flag = true;
													positiveRecords++;
													break;
												}
											}
											console.log(flag);
											if (flag) {
												return (
													<div className="mx-32 grid grid-cols-11 overflow-auto border-b">
														<div
															className="flex col-span-2 py-16"
															// onClick={() => goTostudentInformation(row)}
														>
															<Avatar className="mr-6" src={row?.thumb} />
															<div className="flex flex-col items-start">
																<div className="allergy-homeroom truncate break-word font-bold">
																	{row?.home_room?.name}
																</div>
																<div className="report-staff truncate break-word">{row?.full_name}</div>
																<div className="font-normal student-age-font" style={{ width: '90px' }}>
																	{generateAgeString(row.date_of_birth)}
																</div>
															</div>
														</div>
														{row.immunizations
															.filter((i) => i.is_enabled && !i.is_exempted)
															.map((immunization, i, arr) => {
																const nextDoseIndex = findNextDoseIndex(immunization, age, memo);
																if (nextDoseIndex === -1) {
																	return '';
																}
																const overduein30days = findOverdueIn30Days(immunization.meta[nextDoseIndex], age);
																return (
																	nextDoseIndex !== -1 && (
																		<>
																			<div
																				className={`dueoverdueText col-span-3 flex flex-col py-16 border-l ${
																					overduein30days ? 'bg-red-100' : 'bg-green-100'
																				} ${i !== arr.length - 1 ? 'border-b' : ''}`}
																				style={{
																					placeContent: 'center',
																					placeItems: 'center',
																				}}
																			>
																				<div>
																					{
																						immunizationsList
																							.filter((im) => immunization.immunization_id === im.id)[0]
																							?.name.split('-')[0]
																					}
																				</div>
																				<div className="dose-number">Dose {nextDoseIndex + 1}</div>
																			</div>
																			<div
																				className={`dueoverdueText flex col-span-3 py-16 border-l ${
																					overduein30days ? 'bg-red-100' : 'bg-green-100'
																				} ${i !== arr.length - 1 ? 'border-b' : ''}`}
																				style={{
																					placeContent: 'center',
																					placeItems: 'center',
																				}}
																			>
																				{immunization.meta[nextDoseIndex].duration_text}
																			</div>
																			<div
																				className={`dueoverdueText flex col-span-3 py-16 border-l ${
																					overduein30days ? 'bg-red-100' : 'bg-green-100'
																				} ${i !== arr.length - 1 ? 'border-b' : ''}`}
																				style={{
																					placeContent: 'center',
																					placeItems: 'center',
																				}}
																			>
																				{overduein30days ? 'Yes' : 'No'}
																			</div>
																			<div className="col-span-2" />
																		</>
																	)
																);
															})}
													</div>
												);
											}
											return '';
										})}
									{positiveRecords === 0 ? (
										<div className="flex justify-center items-center" style={{ height: '70%' }}>
											<Typography variant="h6">No upcoming due immunization</Typography>
										</div>
									) : null}
									{fetchingMore ? (
										<div className="flex justify-center items-center">
											<CircularProgress size={35} />
										</div>
									) : null}
								</>
							) : (
								<div className="flex justify-center items-center" style={{ height: '70%' }}>
									<Typography variant="h6">No data found</Typography>
								</div>
							)}
						</div>
					</div>
				</div>
				<div className="due-overdue-table-wrapper rounded-lg bg-white w-full mt-12 overflow-auto" id="Scrollable-table">
					<div className="mx-32 border-b">
						<div className="grid grid-cols-11 dueoverdueHeader">
							<div className="p-16 pl-0 col-span-2">Student</div>
							<div className="p-16 px-8 border-l col-span-3 flex justify-center">Due With in Next 30 Days</div>
							<div className="p-16 px-8 border-l col-span-3 flex justify-center">CDC Recommendation</div>
							<div className="p-16 px-8 border-l col-span-3 flex justify-center">Overdue With in Next 30 Days</div>
						</div>
					</div>
					{firstLoad ? (
						<div className="flex flex-row justify-center items-center" style={{ height: '70%' }}>
							Please Generate Your Report
						</div>
					) : isLoading ? (
						<div className="flex justify-center items-center" style={{ height: '70%' }}>
							<CircularProgress />
						</div>
					) : rows.length > 0 ? (
						<>
							{rows
								.filter((row) => row.immunizations.filter((i) => i.is_enabled && !i.is_exempted).length)
								.map((row) => {
									const age = getAgeDetails(dayjs(row.date_of_birth), dayjs());
									const imms = row.immunizations.filter((i) => i.is_enabled && !i.is_exempted);
									let flag = false;
									for (let i = 0; i < imms.length; i += 1) {
										const nextDoseIndex = findNextDoseIndex(imms[i], age, memo);
										if (nextDoseIndex !== -1) {
											flag = true;
											break;
										}
									}
									if (flag) {
										return (
											<div className="mx-32 grid grid-cols-11 overflow-auto border-b">
												<div
													className="flex col-span-2 py-16"
													// onClick={() => goTostudentInformation(row)}
												>
													<Avatar className="mr-6" src={row?.thumb} />
													<div className="flex flex-col items-start">
														<div className="allergy-homeroom truncate break-word font-bold">{row?.home_room?.name}</div>
														<div className="report-staff truncate break-word">{row?.full_name}</div>
														<div className="font-normal student-age-font" style={{ width: '90px' }}>
															{generateAgeString(row.date_of_birth)}
														</div>
													</div>
												</div>
												{row.immunizations
													.filter((i) => i.is_enabled && !i.is_exempted)
													.map((immunization, i, arr) => {
														const nextDoseIndex = findNextDoseIndex(immunization, age, memo);
														if (nextDoseIndex === -1) {
															return '';
														}
														const overduein30days = findOverdueIn30Days(immunization.meta[nextDoseIndex], age);
														return (
															nextDoseIndex !== -1 && (
																<>
																	<div
																		className={`dueoverdueText col-span-3 flex flex-col py-16 border-l ${
																			overduein30days ? 'bg-red-100' : 'bg-green-100'
																		} ${i !== arr.length - 1 ? 'border-b' : ''}`}
																		style={{
																			placeContent: 'center',
																			placeItems: 'center',
																		}}
																	>
																		<div>
																			{
																				immunizationsList
																					.filter((im) => immunization.immunization_id === im.id)[0]
																					?.name.split('-')[0]
																			}
																		</div>
																		<div className="dose-number">Dose {nextDoseIndex + 1}</div>
																	</div>
																	<div
																		className={`dueoverdueText flex col-span-3 py-16 border-l ${
																			overduein30days ? 'bg-red-100' : 'bg-green-100'
																		} ${i !== arr.length - 1 ? 'border-b' : ''}`}
																		style={{
																			placeContent: 'center',
																			placeItems: 'center',
																		}}
																	>
																		{immunization.meta[nextDoseIndex].duration_text}
																	</div>
																	<div
																		className={`dueoverdueText flex col-span-3 py-16 border-l ${
																			overduein30days ? 'bg-red-100' : 'bg-green-100'
																		} ${i !== arr.length - 1 ? 'border-b' : ''}`}
																		style={{
																			placeContent: 'center',
																			placeItems: 'center',
																		}}
																	>
																		{overduein30days ? 'Yes' : 'No'}
																	</div>
																	<div className="col-span-2" />
																</>
															)
														);
													})}
											</div>
										);
									}
									return '';
								})}
							{positiveRecords === 0 ? (
								<div className="flex justify-center items-center" style={{ height: '70%' }}>
									<Typography variant="h6">No upcoming due immunization</Typography>
								</div>
							) : null}
							{fetchingMore ? (
								<div className="flex justify-center items-center">
									<CircularProgress size={35} />
								</div>
							) : null}
						</>
					) : (
						<div className="flex justify-center items-center" style={{ height: '70%' }}>
							<Typography variant="h6">No data found</Typography>
						</div>
					)}
				</div>
				<InfiniteScroll
					dataLength={rows.length}
					hasMore={hasMore}
					next={handleLoadMore}
					scrollableTarget="Scrollable-table"
				/>
			</div>
		</FuseAnimate>
	);
};
export default ImmunizationReport;
